import type { RouteRecordRaw } from 'vue-router';
import { HasNavigationLayout } from '@/pages/_layout';

const as = 'deliveryRoutes';
const prefix = '/delivery-routes';

export const deliveryRoutes: RouteRecordRaw[] = [
    {
        path: `${prefix}/:vehicleId`,
        name: `${as}.index`,
        // TODO: collectionは適当な名前すぎたので直す（いま修正すると差分大きいのであとで直す）
        component: () => import('@/pages/collection/CollectionPage.vue'),
        props: (route) => ({
            vehicleId: route.params.vehicleId,
        }),
        meta: {
            title: '集配先ルート一覧',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
    {
        path: `${prefix}/:vehicleId/destinations/:destinationId/luggage`,
        name: `${as}.luggageWork`,
        component: () => import('@/pages/luggage-pickup/LuggagePickupPage.vue'),
        props: (route) => ({
            vehicleId: route.params.vehicleId,
            destinationId: route.params.destinationId,
            mode: route.query.mode,
            hotelId: route.query.hotelId,
            visitTime: route.query.visitTime,
            airportReceptionId: route.query.airportReceptionId,
        }),
        meta: {
            title: '集荷・配送作業',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
    {
        path: `${prefix}/:vehicleId/destinations/:destinationId/hotel-handover`,
        name: `${as}.hotelHandover`,
        component: () => import('@/pages/hotel-handover/HotelHandoverPage.vue'),
        props: (route) => ({
            vehicleId: route.params.vehicleId,
            destinationId: route.params.destinationId,
            hotelId: route.query.hotelId,
            visitTime: route.query.visitTime,
        }),
        meta: {
            title: 'ホテル受け渡し',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
];
